import React from "react";
import {
  CalendarCheckIcon,
  PeopleIcon,
  ReceiptAddIcon,
  RoomServiceIcon,
} from "components/Icons";

const iconMap = {
  total: <RoomServiceIcon size={18} />,
  available: <ReceiptAddIcon size={18} />,
  active: <PeopleIcon size={18} />,
  reservation: <CalendarCheckIcon size={18} />,
};

const colorMap = {
  total: "bg-purple-100 text-purple-600",
  available: "bg-green-100 text-green-600",
  active: "bg-yellow-100 text-yellow-600",
  reservation: "bg-blue-100 text-blue-600",
};

export default function TableStats({ stats, onFilter, activeFilter }) {
  return (
    <div className="flex flex-wrap gap-3 justify-start my-4 px-1">
      {Object.entries(stats).map(([key, count]) => (
        <button
          key={key}
          onClick={() => onFilter(key)}
          className={`flex items-center justify-between w-36 md:min-w-[180px] px-1 md:px-4 py-2 h-12 rounded-xl shadow-sm
            ${colorMap[key] || "bg-gray-100 text-gray-600"} 
            hover:opacity-90 transition
            ${activeFilter === key ? "ring-2 ring-offset-2 ring-gray-400" : ""}
          `}
        >
          <div className="flex items-center gap-2">
            {iconMap[key] || null}
            <span className="font-semibold capitalize">{key}:</span>
          </div>
          <span className="font-bold">{count}</span>
        </button>
      ))}
    </div>
  );
}
